(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");
var $59bdea93f29f00f1$var$nav = {
    hamburger: function() {
        var hamburger = document.querySelector('.nav-toggle');
        if (!hamburger) return;
        var container = document.querySelector('body');
        hamburger.addEventListener('click', function() {
            hamburger.classList.toggle('nav--toggled');
            container.classList.toggle('nav--toggled');
        });
    }
};
var $59bdea93f29f00f1$export$2e2bcd8739ae039 = $59bdea93f29f00f1$var$nav;


/**
 * Hoteltip button link functionality
 *
 * Finds all hoteltip blocks and sets the button href
 * to match any link found within the hoteltip block
 */ var $1b7b2af2ce32c79e$export$2e2bcd8739ae039 = {
    init: function() {
        var hoteltips = document.querySelectorAll('.hoteltip');
        hoteltips.forEach(function(hoteltip) {
            // Find any link within the hoteltip block (excluding the button itself)
            var link = hoteltip.querySelector('a:not(.wp-block-button__link)');
            // Find the button within this hoteltip
            var button = hoteltip.querySelector('.wp-block-button__link');
            // If both link and button exist, set button href to link's href
            if (link && button && link.href) button.href = link.href;
        });
    }
};


var $66db61075a618e26$var$scrollRestoration = {
    disable: function() {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    }
};
var $66db61075a618e26$export$2e2bcd8739ae039 = $66db61075a618e26$var$scrollRestoration;


var $847553d13b80c4b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function App() {
        (0, $bB0zn._)(this, App);
    }
    (0, $6QEWP._)(App, [
        {
            key: "initCore",
            value: function initCore() {
                (0, $66db61075a618e26$export$2e2bcd8739ae039).disable();
                (0, $59bdea93f29f00f1$export$2e2bcd8739ae039).hamburger();
                (0, $1b7b2af2ce32c79e$export$2e2bcd8739ae039).init();
            }
        }
    ]);
    return App;
}();
function $847553d13b80c4b3$var$LoadApp() {
    var app = new $847553d13b80c4b3$export$2e2bcd8739ae039();
    app.initCore();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $847553d13b80c4b3$var$LoadApp);
else $847553d13b80c4b3$var$LoadApp();

})();
//# sourceMappingURL=_app.js.map
